export var IconType;
(function (IconType) {
    IconType[IconType["CLOSE_MENU"] = 0] = "CLOSE_MENU";
    IconType[IconType["OPEN_MENU"] = 1] = "OPEN_MENU";
})(IconType || (IconType = {}));
